import React from 'react';
import { RichText } from 'prismic-reactjs';
import renderButtons from './../helpers/renderButtons';
import { get } from 'lodash';

export default function TextSlice(slice) {
  const logo = get(slice, 'primary.logo.url');
  const textAlign = get(slice, 'primary.text_alignment');

  const backgroundStyle = {
    backgroundColor: get(slice, 'primary.background_color'),
    color: get(slice, 'primary.text_color')
  };

  const alignText = val => {
    if (val === 'Center') {
      return 'center';
    }
    if (val === 'Right') {
      return 'right';
    } else {
      return 'left';
    }
  };

  return (
    <section className="text-slice section-padding-2 cool-margin" style={backgroundStyle}>
      <div className="wrapper">
        {logo && (
          <div className="text-slice-logo">
            <img src={logo} alt="" role="presentation" />
          </div>
        )}
        <div className={`text-content ${alignText(textAlign)}`}>
          <RichText render={get(slice, 'primary.content')} />
          <div className="buttons">{renderButtons(get(slice, 'items'))}</div>
        </div>
      </div>
    </section>
  );
}
